import $ from 'jquery'
import ui from 'jquery-ui/dist/jquery-ui.js'

window.jQuery = window.$ = $
window.jQuery.ui = ui
